import {
  Button,
  styled,
  Tooltip,
  tooltipClasses,
  TooltipProps,
} from "@mui/material";
import { PackageResponse } from "../../app/models/responseModels/packageResponse";

const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    sx={{ fontSize: 40 }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.warning.light,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.warning.light,
    fontSize: theme.typography.pxToRem(14),
  },
}));

type RecipientDetailsTooltipProps = {
  packageData: PackageResponse;
};

const PackageRecipientDetailsTooltip = ({
  packageData,
}: RecipientDetailsTooltipProps) => {
  return (
    <>
      <div>Name: {packageData.shipmentRecipientName}</div>
      {/* <div>Phone: {packageData.shipmentRecipientPhone}</div> */}
      <div>Address Line 1:- {packageData.shipmentRecipientAddressLine1}</div>

      <>
        <div>
          <BootstrapTooltip
            //open={open}
            PopperProps={{
              disablePortal: false,
            }}
            title={
              <ul style={{ padding: "inherit", listStyleType: "none" }}>
                <li>Name:- {packageData.shipmentRecipientName}</li>
                {/* <li>Phone:- {packageData.shipmentRecipientPhone}</li> */}
                <li>
                  Address Line 1:- {packageData.shipmentRecipientAddressLine1}
                </li>
                <li>
                  Address Line 2:- {packageData.shipmentRecipientAddressLine2}
                </li>
                <li>City:- {packageData.shipmentRecipientCity}</li>
                <li>State:- {packageData.shipmentRecipientState}</li>
                <li>Zip:- {packageData.shipmentRecipientZip}</li>
              </ul>
            }
          >
            <Button
              sx={{
                textTransform: "lowercase",
                padding: "8px",
                lineHeight: "0px",
                color: "blue",
              }}
              disableElevation={true}
              disableRipple={true}
              size="large"
            >
              more...
            </Button>
          </BootstrapTooltip>
        </div>
      </>
    </>
  );
};

export default PackageRecipientDetailsTooltip;
